import { render, staticRenderFns } from "./FormSubmitted.vue?vue&type=template&id=c00cea16&scoped=true&"
var script = {}
import style0 from "./FormSubmitted.vue?vue&type=style&index=0&id=c00cea16&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00cea16",
  null
  
)

export default component.exports